<template>
  <div :class="['video-container', type]">
    <video
      ref="video"
      class="video"
      controls
      :src="data.preview_video_info.video_url"
      loop
      poster=""
      controlslist="nofullscreen nodownload"
      disablePictureInPicture
      autoplay
    />
    <div class="subtitles">
      <div v-for="item in currenSubtitle" :key="item.text">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVideoSubtitle } from '~/hooks/useVideoSubtitle'

interface TextData {
  alpha: number
  color: string
  fontFamily: string
  fontSize: number
  height: number
  rotation: number
  scale: number
  text: string
  textAlign: string
  type: string
  width: number
  x: number
  y: number
}

const props = defineProps<{
  data: any
  type: string
}>()

const currenSubtitle = ref<TextData[]>([])
const video = ref<HTMLVideoElement | null>(null)

const videoData = await useVideoSubtitle(props.data.generate_record_id)

const handleVideoPlay = () => {
  const texts: TextData[] = []
  videoData!.forEach((item) => {
    const currentTime = video.value!.currentTime
    if (item.show_time <= currentTime && item.hide_time > currentTime) {
      texts.push(item.metadata)
    }
  })
  currenSubtitle.value = texts
}

onMounted(() => {
  video.value?.addEventListener('timeupdate', handleVideoPlay)
})

onBeforeUnmount(() => {
  video.value?.removeEventListener('timeupdate', handleVideoPlay)
})
</script>

<style lang="scss" scoped>
.subtitles {
  pointer-events: none;
  width: 76%;
  color: var(--back-0-80);
  transform: translate(-50%);
  left: 50%;
  line-height: 36px;
  position: absolute;
  font-family: Tahoma, Geneva, Verdana;
  font-size: 16px;
  z-index: 9;
  bottom: 3%;
  text-align: center;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 10%,
    rgba(0, 0, 0, 0.4) 90%,
    rgba(0, 0, 0, 0) 100%
  );
}

.video-container {
  position: relative;
  background-color: #efefef;
}

.video {
  height: 100%;
  width: 100%;
}

.vertical {
  .subtitles {
    width: 51%;
    line-height: 28px;
    font-size: 14px;
    bottom: 3%;
    transform: translate(-50%) scale(0.58);
    transform-origin: center bottom;
  }
}
</style>
